import {
  ResponsiveContainer,
  Bar,
  BarChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  LabelList,
} from "recharts";

export default function TeacherTurnOverByDistrictChart({ data }) {
  const type = data.length > 0 ? data[0].type : undefined;
  const sortedData = [...data].sort((a, b) => b.count - a.count);

  return (
    <ResponsiveContainer
      width="100%"
      height={type !== "DISTRICT" ? 590 : 995}
      style={{ display: "flex", justifyContent: "flex-start" }}
    >
      <BarChart
        data={sortedData}
        layout="vertical"
        margin={{ top: 10, right: 20, left: -30, bottom: 10 }}
      >
        <CartesianGrid strokeDasharray="3 3" horizontal={false} />
        <XAxis type="number" />
        <YAxis
          type="category"
          dataKey="name"
          width={150}
          orientation="left"
          tick={{ textAnchor: "start", dx: -95 }}
        />
        <Tooltip
          formatter={(value, label) => [
            `${value?.toLocaleString()} ${value == 1 ? "Teacher" : "Teachers"}`,
            label,
          ]}
        />
        <Legend />
        <Bar
          dataKey="count"
          fill="hsl(var(--chart-1))"
          name="Turnovers"
          {...(type === "DISTRICT" ? { barSize: 16 } : {})}
        >
          <LabelList
            dataKey="count"
            position="right"
            formatter={(value) => value.toLocaleString()}
            style={{ fill: "black", fontWeight: "bold", fontSize: 14 }}
          />
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
}
